export default __webpack_public_path__ + "images/f7e4f70dba54a14135e147fe0f2c481b-nye_header_tablet.webp";